<script>
export default {
    name: "ReceivedPaymentsReport",

    data() {

        return {
            filter: {
                search: ``,
                dateFrom: window.moment().format(`YYYY-MM-DD`),
                dateTo: window.moment().format(`YYYY-MM-DD`),
            },
            payments: [],
        };
    },

    computed: {

        totalPaidAmt() {
            if(!this.payments.length && !this.payments.billPaymentsReport) return 0;

            if(!this.payments.billPaymentsReport.length) return 0;

            return this.payments.billPaymentsReport.map(payment => payment.amount ? parseFloat(payment.amount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalCreditAmt() {
            if(!this.payments.length && !this.payments.billPaymentsReport) return 0;

            if(!this.payments.billPaymentsReport.length) return 0;

            return this.payments.billPaymentsReport.map(payment => payment.creditAmount ? parseFloat(payment.creditAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalReceiptAmt() {
            if(!this.payments.length && !this.payments.billPaymentsReport) return 0;

            if(!this.payments.billPaymentsReport.length) return 0;

            return this.payments.billPaymentsReport.map(payment => payment.receiptAmount ? parseFloat(payment.receiptAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalDepositAmt() {
            if(!this.payments.length && !this.payments.depositsReport) return 0;

            if(!this.payments.depositsReport.length) return 0;

            return this.payments.depositsReport.map(dep => dep.depositAmount ? parseFloat(dep.depositAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalAllocatedAmt() {
            if(!this.payments.length && !this.payments.depositsReport) return 0;

            if(!this.payments.depositsReport.length) return 0;

            return this.payments.depositsReport.map(dep => dep.amountAllocated ? parseFloat(dep.amountAllocated) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalUnallocatedAmt() {
            if(!this.payments.length && !this.payments.depositsReport) return 0;

            if(!this.payments.depositsReport.length) return 0;

            return this.payments.depositsReport.map(dep => dep.unAllocatedAmount ? parseFloat(dep.unAllocatedAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalCashOut() {

            if(!this.payments.length && !this.payments.cashReport ) return 0;

            if(!this.payments.cashReport.length) return 0;

            return this.payments.cashReport.map(cOut => cOut.amount ? parseFloat(cOut.amount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalReceivedAmount() {

            return this.totalPaidAmt + this.totalDepositAmt;
        },

        tillAmount() {

            return this.totalReceivedAmount - (this.totalCreditAmt + this.totalCashOut);
        },
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ this.fetchReceivedPayments(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchReceivedPayments() {
            if(!this.filter.dateFrom && !this.filter.dateTo) return Promise.reject();

            let url = `AccountsReports/GetReceivedDeclaredCashPayments`;
                url += `?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
                url += this.$route.query.Cashier ? `&Cashier=${this.$route.query.Cashier}` : ``;
                url += this.$route.query.PaymentMode ? `&PaymentMode=${this.$route.query.PaymentMode}` : ``;
                url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;

            return this.$http.get(url).then(response => { 
                    this.payments = response.data; 
                }).catch(() => {});
        },
        RecordUserActivity() {
          this.userActivityModels.userActivity="Page Access: "+this.$root.username+": Successfully Accessed Received Payment Report";
          this.userActivityModels.userHostAddress=window.location.host;
          this.userActivityModels.userHostAddress=window.location.hostname;
          
          this.$root.loading = true;
                this.$http.post(`Admin/RecordUserActivity`, this.userActivityModels).then(response => {
                     
                  this.responsemsg= response.data;
                    this.$root.loading = false;
                 }).catch(() => { this.$root.loading = false; });

          
        },
    },
}
</script>
<template>
<div class="flex flex-wrap content-start">
    <div class="w-full my-2 p-1 text-center">
        <h5 class="font-bold text-base">Received Payments report</h5>
    </div>
    <div class="w-full p-tiny">
        <h5 class="font-semibold text-base">Payments Against Bills</h5>
    </div>
    <table class="table" id="receivedPaymentsReport">
        <tbody class="text-xs">
            <tr>
                <th class="p-tiny">Time (d-m-y)</th>
                <th class="p-tiny">Patient</th>
                <th class="p-tiny">MRN No</th>
                <th class="p-tiny">Receipt No</th>
                <th class="p-tiny">Paid</th>
                <th class="p-tiny">Reversed</th>
                <th class="p-tiny">Receipt</th>
                <th class="p-tiny">Memo</th>
                <th class="p-tiny">Username</th>
            </tr>
            <tr v-for="(payment, idx) in payments.billPaymentsReport" :key="idx">
                <td class="p-tiny">{{ payment.sysDate }}</td>
                <td class="p-tiny">{{ payment.patient }}</td>
                <td class="p-tiny">{{ payment.patienT_ID || `-` }}</td>
                <td class="p-tiny">{{ payment.receipt_No || `-` }}</td>
                <td class="p-tiny">{{ payment.amount | numberFormat }}</td>
                <td class="p-tiny">{{ payment.creditAmount | numberFormat }}</td>
                <td class="p-tiny">{{ payment.receiptAmount | numberFormat }}</td>
                <td class="p-tiny">{{ payment.refNo || `-` }}</td>
                <td class="p-tiny">{{ payment.userName }}</td>
            </tr>
            <!-- <tr>
                <th scope="row" colspan="8" class="p-tiny"></th>
                <th scope="row" class="p-tiny">Paid Amt: {{ totalPaidAmt | numberFormat }}</th>
                <th scope="row" class="p-tiny">Credit Amt: {{ totalCreditAmt | numberFormat }}</th>
                <th scope="row" class="p-tiny">Receipt Amt: {{ totalReceiptAmt | numberFormat }}</th>
            </tr> -->
        </tbody>
    </table>
    
    <div class="w-full p-1 text-center">
        <h5 class="font-bold text-base">Total Periodic Collections</h5>
    </div>
    <div class="w-full flex flex-row bg-gray-300 p-1 my-1">
        <div class="flex-1">
            <h5 class="font-semibold text-base">
                Received Amount: {{ totalReceivedAmount | numberFormat }}</h5>
        </div>
        <div class="flex-1">
            <h5 class="font-semibold text-base">
                Credit Amount: {{ totalCreditAmt | numberFormat }}</h5>
        </div>
        
        <div class="flex-1">
            <h5 class="font-semibold text-base">Till Amount: {{ tillAmount | numberFormat }}</h5>
        </div>
    </div>
</div>
</template>
